export const isEqual = (arrOne: string[], arrTwo: string[]): boolean => arrOne.length === arrTwo.length && arrOne.every(val => arrTwo.some(valTwo => val === valTwo));
